/**
 * Icon codes parsed from IcoMoon font string-icons.
 *
 * DO NOT EDIT! This file is automatically generated from resources/fonts/icons/selection.json
 */
export enum IconCodes {
	"_chevron_up" = "\\0e900",
	"_chevron_down" = "\\0e901",
	"_chevron_left" = "\\0e902",
	"_chevron_right" = "\\0e903",
	"_undo" = "\\0e904",
	"_redo" = "\\0e905",
	"_ruler" = "\\0e906",
}
